export default __webpack_public_path__ + "static/media/councilpoweredby2.d382a19c.png";